module.exports = __webpack_public_path__ + "img/logo-ruinart-art.427edc2c.png";